export const GET_ALL_INVOICES = 'GET_ALL_INVOICES'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_SINGLE_INVOICE = 'GET_SINGLE_INVOICE'
export const GET_SINGLE_SELLER_INVOICE = 'GET_SINGLE_SELLER_INVOICE'
export const GET_INVOICE_DETAILS = 'GET_INVOICE_DETAILS'
export const GET_MULTIPLE_INVOICE = 'GET_MULTIPLE_INVOICE'
export const GET_CONTENT_INVOICE = 'GET_CONTENT_INVOICE'
export const GET_EMAIL_INVOICE = 'GET_EMAIL_INVOICE'
